import { render } from "./pc.vue?vue&type=template&id=0a8098de&scoped=true&ts=true"
import script from "./pc.vue?vue&type=script&lang=ts"
export * from "./pc.vue?vue&type=script&lang=ts"

import "./pc.vue?vue&type=style&index=0&id=0a8098de&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8098de"]])

export default __exports__